var _ = require('underscore');
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<li class="CDB-Widget-listItem CDB-Widget-listItem--fake"></li>\n<li class="CDB-Widget-listItem CDB-Widget-listItem--fake"></li>\n<li class="CDB-Widget-listItem CDB-Widget-listItem--fake"></li>\n<li class="CDB-Widget-listItem CDB-Widget-listItem--fake"></li>\n';

}
return __p
}